<template>
  <div class="card column grid-4-g grid-11-s grid-11-m justify-space">
    <div class="row">
      <div class="title grid-12">JOB {{ job.id_job || job.id }}</div>
    </div>
    <div class="row">
      <div class="column grid-7">
        <div v-if="job.status != 'desistiu'">
          <span>Agendando Para</span>
          {{
            new Date(job.dh_agendamento_cliente).toLocaleString().substr(0, 16)
          }}
        </div>
        <div class="canceled" v-else>Candidatura Cancelada</div>
      </div>
      <div class="column justify-center city">
        {{ job.cidade }}/{{ job.estado }}
      </div>
    </div>
    <div class="row buttons">
      <div class="grid-7" v-if="map">
        <Button
          layout="white-m"
          @click="(marker) => map(marker)"
        >
          <img src="../assets/img/google.svg" alt />
          <div>Ver local de atendimento</div>
        </Button>
      </div>
      <div class="row column-s grid-11" v-if="!apply">
        <div class="grid-12 justify-center row">
          <router-link :to="'/job/candidato/' + job.id_job">
            <Button layout="green-dark-p">MAIS DETALHES</Button>
          </router-link>
        </div>
        <div
          class="grid-12-s grid-4-g row justify-center-s"
          v-if="job.status != 'desistiu'"
        >
          <Button
            layout="red-s"
            class="justify-center row"
            @click="cancelJob"
            :loader="buttonLoader"
            >CANCELAR</Button
          >
        </div>
      </div>
      <div class="row grid-12 justify-center" v-else>
        <router-link :to="'/job/token/' + job.token_divulgacao">
          <Button layout="green-go" class="justify-center row"
            >QUERO ME CANDIDATAR</Button
          >
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button.vue";
import { mapActions } from "vuex";
import Router from "@/router";

export default {
  components: {
    Button,
  },
  data() {
    return {
      router: Router,
      buttonLoader: false,
    };
  },
  props: {
    apply: {
      type: Boolean,
    },
    job: {
      type: Object,
      required: true,
    },
    map: {
      type: Boolean,
      required: false,
    },
  },
  methods: {
    ...mapActions("job", ["CANCEL_CANDIDATE"]),
    cancelJob() {
      this.buttonLoader = true;
      if (confirm("Deseja realmente cancelar a candidatura ao Job?"))
        this.CANCEL_CANDIDATE(this.job.id)
          .then(() => (this.buttonLoader = false))
          .catch(() => (this.buttonLoader = false));
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";
.card {
  background: $white;
  box-shadow: 0px 6px 16px #00000029;
  border-radius: 17px;
  color: $gray-1;
  padding: 25px;
  padding-top: 30px;
  margin-right: 40px;
  font-size: 14px;
  font-weight: 500;
  margin-top: 40px;
  max-height: 135px;
  @media (max-width: $small) {
    max-height: 200px;
  }
  .canceled {
    color: $red-2;
  }
  @media (max-width: $small) {
    margin-right: 20px;
  }
  .city {
    color: $gray-4;
  }
  .title {
    color: $black;
    font-size: 17px;
    font-weight: bold;
    padding-bottom: 23px;
  }
  span {
    color: $gray-6;
    font-weight: 300;
  }
  .margin-top {
    margin-top: 16px;
  }
  .buttons {
    margin-top: 30px;

    .button-white-m {
      width: 38px;
      height: 35px;
      padding: 0px 10px;
      overflow: hidden;
      div {
        width: 180px;
        display: block;
      }
      img {
        margin-top: -4px;
      }
      &:hover {
        width: 215px;
        img {
          margin-top: 0px;
        }
      }
    }
    .button-white-green {
      max-width: 140px;
    }
    .button-green-dark-p {
      @media (max-width: $small) {
        width: 200px;
        margin-bottom: 10px;
      }
    }
    .button-red-s {
      line-height: 23px;
      @media (max-width: $small) {
        margin-top: 10px;
        width: 200px;
      }
    }
  }
}
</style>
